import {
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { ToogleComponent } from '../../toogle/toogle.component';
import { ColumnDataType } from '../../../model/column-definition';
import { ValueChangeEvent } from '../../forms/input-control.base';
import { BooleanTextPipe } from '../../../pipe/boolean-text.pipe';

@Component({
    selector: 'dh-custom-toogle-view',
    template: `@if (viewType) {
} @else {
  @if (helpText) {
    <astral-popover [helpText]="helpText"></astral-popover>
    }{{value}}
    }`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DataCellToogleComponent implements OnInit, OnDestroy {
  constructor(
    private _e: ElementRef,
    private _host: ViewContainerRef,
    private _booleanTextPipe: BooleanTextPipe
  ) {}

  @Input() viewType: any;
  @Input() value: any;
  @Input() helpText: any;
  @Output() toggleChanged = new EventEmitter<boolean>();

  private _c: ComponentRef<any>;
  get hostWidth(): number {
    return this._e.nativeElement.offsetWidth;
  }

  ngOnDestroy() {
    if (this._c) {
      this._c.destroy();
      this._c = null;
    }
  }

  ngOnInit() {
    if (this.viewType) {
      if (this.viewType === ColumnDataType.boolean) {
        this._c = this._host.createComponent(ToogleComponent);
        const boolValue = typeof this.value === 'string' ? this._booleanTextPipe.toBoolean(this.value) : this.value;
        this._c.instance.dataContext = boolValue;

        // Pass the event up
        if (this.viewType === ColumnDataType.boolean) {
          this._c.instance.valueChange.subscribe((e: ValueChangeEvent) => {
            this.toggleChanged.emit(e.newValue);
          });
        }
      } else {
        this._c = this._host.createComponent(this.viewType);
        this._c.instance.dataContext = this.value;
      }
    }
  }
}
